export const idealInquiryFormViewed = 'ideal_inquiry_form_viewed';

export const idealInquiryFormSearchSubmitted =
  'ideal_inquiry_form_search_submitted';

export const idealInquiryFormSubmitted = 'ideal_inquiry_form_submitted';

export const idealInquiryFormSubmitError = 'ideal_inquiry_form_submit_error';

export const idealInquiryFormSearchError = 'ideal_inquiry_form_search_error';
